import { Vector3 } from "@babylonjs/core/Maths/math.vector";
export class ImmediateRigidBodyBundleImpl {
    shouldSync;
    _count;
    constructor(count) {
        this.shouldSync = true;
        this._count = count;
    }
    setTransformMatrixFromArray(motionStatesPtr, kinematicStatesPtr, index, array, offset) {
        const m = motionStatesPtr.array;
        const mOffset = index * 20 /* Constants.MotionStateSizeInFloat32Array */;
        m[mOffset + 4 /* MotionStateOffsetsInFloat32Array.MatrixRowX */ + 0] = array[offset];
        m[mOffset + 8 /* MotionStateOffsetsInFloat32Array.MatrixRowY */ + 0] = array[offset + 1];
        m[mOffset + 12 /* MotionStateOffsetsInFloat32Array.MatrixRowZ */ + 0] = array[offset + 2];
        m[mOffset + 4 /* MotionStateOffsetsInFloat32Array.MatrixRowX */ + 1] = array[offset + 4];
        m[mOffset + 8 /* MotionStateOffsetsInFloat32Array.MatrixRowY */ + 1] = array[offset + 5];
        m[mOffset + 12 /* MotionStateOffsetsInFloat32Array.MatrixRowZ */ + 1] = array[offset + 6];
        m[mOffset + 4 /* MotionStateOffsetsInFloat32Array.MatrixRowX */ + 2] = array[offset + 8];
        m[mOffset + 8 /* MotionStateOffsetsInFloat32Array.MatrixRowY */ + 2] = array[offset + 9];
        m[mOffset + 12 /* MotionStateOffsetsInFloat32Array.MatrixRowZ */ + 2] = array[offset + 10];
        m[mOffset + 16 /* MotionStateOffsetsInFloat32Array.Translation */ + 0] = array[offset + 12];
        m[mOffset + 16 /* MotionStateOffsetsInFloat32Array.Translation */ + 1] = array[offset + 13];
        m[mOffset + 16 /* MotionStateOffsetsInFloat32Array.Translation */ + 2] = array[offset + 14];
        const kinematicStates = kinematicStatesPtr.array;
        if ((kinematicStates[index] & 240 /* TemporalKinematicState.ReadMask */) !== 0 /* TemporalKinematicState.Disabled */) {
            kinematicStates[index] = (kinematicStates[index] & 15 /* TemporalKinematicState.WriteMask */) | 32 /* TemporalKinematicState.WaitForChange */;
        }
    }
    setTransformMatricesFromArray(motionStatesPtr, kinematicStatesPtr, array, offset) {
        const m = motionStatesPtr.array;
        const kinematicStates = kinematicStatesPtr.array;
        const count = this._count;
        let mOffset = 0;
        let aOffset = offset;
        for (let i = 0; i < count; ++i) {
            m[mOffset + 4 /* MotionStateOffsetsInFloat32Array.MatrixRowX */ + 0] = array[aOffset];
            m[mOffset + 8 /* MotionStateOffsetsInFloat32Array.MatrixRowY */ + 0] = array[aOffset + 1];
            m[mOffset + 12 /* MotionStateOffsetsInFloat32Array.MatrixRowZ */ + 0] = array[aOffset + 2];
            m[mOffset + 4 /* MotionStateOffsetsInFloat32Array.MatrixRowX */ + 1] = array[aOffset + 4];
            m[mOffset + 8 /* MotionStateOffsetsInFloat32Array.MatrixRowY */ + 1] = array[aOffset + 5];
            m[mOffset + 12 /* MotionStateOffsetsInFloat32Array.MatrixRowZ */ + 1] = array[aOffset + 6];
            m[mOffset + 4 /* MotionStateOffsetsInFloat32Array.MatrixRowX */ + 2] = array[aOffset + 8];
            m[mOffset + 8 /* MotionStateOffsetsInFloat32Array.MatrixRowY */ + 2] = array[aOffset + 9];
            m[mOffset + 12 /* MotionStateOffsetsInFloat32Array.MatrixRowZ */ + 2] = array[aOffset + 10];
            m[mOffset + 16 /* MotionStateOffsetsInFloat32Array.Translation */ + 0] = array[aOffset + 12];
            m[mOffset + 16 /* MotionStateOffsetsInFloat32Array.Translation */ + 1] = array[aOffset + 13];
            m[mOffset + 16 /* MotionStateOffsetsInFloat32Array.Translation */ + 2] = array[aOffset + 14];
            if ((kinematicStates[i] & 240 /* TemporalKinematicState.ReadMask */) !== 0 /* TemporalKinematicState.Disabled */) {
                kinematicStates[i] = (kinematicStates[i] & 15 /* TemporalKinematicState.WriteMask */) | 32 /* TemporalKinematicState.WaitForChange */;
            }
            mOffset += 20 /* Constants.MotionStateSizeInFloat32Array */;
            aOffset += 16;
        }
    }
    setDynamicTransformMatrixFromArray(worldTransformPtrArray, index, array, offset) {
        const m = worldTransformPtrArray[index].array;
        m[0 /* BtTransformOffsets.MatrixRowX */ + 0] = array[offset];
        m[16 /* BtTransformOffsets.MatrixRowY */ + 0] = array[offset + 1];
        m[32 /* BtTransformOffsets.MatrixRowZ */ + 0] = array[offset + 2];
        m[0 /* BtTransformOffsets.MatrixRowX */ + 1] = array[offset + 4];
        m[16 /* BtTransformOffsets.MatrixRowY */ + 1] = array[offset + 5];
        m[32 /* BtTransformOffsets.MatrixRowZ */ + 1] = array[offset + 6];
        m[0 /* BtTransformOffsets.MatrixRowX */ + 2] = array[offset + 8];
        m[16 /* BtTransformOffsets.MatrixRowY */ + 2] = array[offset + 9];
        m[32 /* BtTransformOffsets.MatrixRowZ */ + 2] = array[offset + 10];
        m[48 /* BtTransformOffsets.Translation */ + 0] = array[offset + 12];
        m[48 /* BtTransformOffsets.Translation */ + 1] = array[offset + 13];
        m[48 /* BtTransformOffsets.Translation */ + 2] = array[offset + 14];
    }
    getEffectiveKinematicState(kinematicStatesPtr, index) {
        return (kinematicStatesPtr.array[index] & 15 /* KinematicToggleState.ReadMask */) !== 0 /* KinematicToggleState.Disabled */;
    }
    setEffectiveKinematicState(kinematicStatesPtr, index, value) {
        const kinematicStates = kinematicStatesPtr.array;
        if (value) {
            kinematicStates[index] = (kinematicStates[index] & 240 /* KinematicToggleState.WriteMask */) | 1 /* KinematicToggleState.Enabled */;
        }
        else {
            kinematicStates[index] = (kinematicStates[index] & 240 /* KinematicToggleState.WriteMask */) | 0 /* KinematicToggleState.Disabled */;
        }
    }
    setDamping(wasmInstance, bundlePtr, index, linearDamping, angularDamping) {
        wasmInstance.rigidBodyBundleSetDamping(bundlePtr, index, linearDamping, angularDamping);
    }
    getLinearDamping(wasmInstance, bundlePtr, index) {
        return wasmInstance.rigidBodyBundleGetLinearDamping(bundlePtr, index);
    }
    getAngularDamping(wasmInstance, bundlePtr, index) {
        return wasmInstance.rigidBodyBundleGetAngularDamping(bundlePtr, index);
    }
    setMassProps(wasmInstance, bundlePtr, index, mass, localInertia) {
        wasmInstance.rigidBodyBundleSetMassProps(bundlePtr, index, mass, localInertia.x, localInertia.y, localInertia.z);
    }
    getMass(wasmInstance, bundlePtr, index) {
        return wasmInstance.rigidBodyBundleGetMass(bundlePtr, index);
    }
    getLocalInertia(wasmInstance, bundlePtr, index) {
        const outBufferPtr = wasmInstance.allocateBuffer(3 * 4 /* Constants.A32BytesPerElement */);
        const outBuffer = wasmInstance.createTypedArray(Float32Array, outBufferPtr, 3).array;
        wasmInstance.rigidBodyBundleGetLocalInertia(bundlePtr, index, outBufferPtr);
        const result = new Vector3(outBuffer[0], outBuffer[1], outBuffer[2]);
        wasmInstance.deallocateBuffer(outBufferPtr, 3 * 4 /* Constants.A32BytesPerElement */);
        return result;
    }
    translate(wasmInstance, bundlePtr, index, translation) {
        wasmInstance.rigidBodyBundleTranslate(bundlePtr, index, translation.x, translation.y, translation.z);
    }
}
